// src/extenders/highlighted-products.js
var HighlightedProducts = class extends HTMLElement {
  constructor() {
    super();
    const allSubjects = this.querySelectorAll(".js-highlights-subject");
    const allHighlights = this.querySelectorAll(".js-highlight");
    const allButtons = this.querySelectorAll(".js-subject-button");
    const handleSubjectSelection = (subject) => {
      allSubjects.forEach((subject2) => {
        subject2.getAttribute("aria-expanded") === "true" ? subject2.setAttribute("aria-expanded", "false") : "";
      });
      subject.setAttribute("aria-expanded", "true");
      const subjectAriaControls = subject.getAttribute("aria-controls");
      allHighlights.forEach((highlight) => {
        const ariaLabelledByHighlight = highlight.getAttribute("aria-labelledby");
        if (ariaLabelledByHighlight === subjectAriaControls) {
          highlight.classList.remove("hidden");
          highlight.classList.add("block");
        } else {
          highlight.classList.remove("block");
          highlight.classList.add("hidden");
        }
      });
      allButtons.forEach((button) => {
        const buttonSubject = button.getAttribute("data-subject");
        if (buttonSubject === subjectAriaControls) {
          button.classList.remove("hidden");
          button.classList.add("block");
        } else {
          button.classList.remove("block");
          button.classList.add("hidden");
        }
      });
    };
    allSubjects.forEach((subject) => {
      subject.addEventListener("click", function() {
        handleSubjectSelection(subject);
      });
    });
    allSubjects.forEach((subject) => {
      if (subject.getAttribute("aria-expanded") === "true") {
        handleSubjectSelection(subject);
      }
    });
  }
};
if (customElements.get("highlighted-products") === void 0) {
  customElements.define("highlighted-products", HighlightedProducts);
}
